import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Header, FieldName, FieldValue } from '../_local/styles'
import Chip from '@material-ui/core/Chip'
import Pencil from '@material-ui/icons/Edit'
import WorkExperienceDialog from '../_local/modals/WorkExperienceDialog'
import { getWorkExperienceFields } from '../service'
import { Box, Button } from '@material-ui/core'

export const getHtmlForEachTag = (tags) => {
  return (
    <FieldValue>
      {tags.map((tag, index) => (
        <Chip key={index} label={`${tag}`} size="small" style={{ margin: 5 }} />
      ))}
    </FieldValue>
  )
}

const WorkExperienceRow = (props) => {
  const { workExperiences, setPropChange } = props
  const [open, setOpen] = useState(false)

  const {
    id,
    title,
    employer,
    isCurrentEmployer,
    startDate,
    endDate,
    industryTags,
    description,
    financialTags,
    softwareTags,
  } = workExperiences

  const initialValues: any = {
    workExperiences:
      workExperiences.length >= 1
        ? workExperiences
        : [
            {
              id: id || undefined,
              title: title || '',
              employer: employer || '',
              isCurrentEmployer: isCurrentEmployer || false,
              startDate: startDate || null,
              endDate: endDate || null,
              industryTags: industryTags || [],
              description: description || '',
              financialTags: financialTags || [],
              softwareTags: softwareTags || [],
              hasExternalProjects: false,
            },
          ],
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Header>Work Experience</Header>
        </Grid>
        <Grid item>
          <Button onClick={handleClickOpen} startIcon={<Pencil />} color="primary">
            Edit
          </Button>
        </Grid>
      </Grid>

      <Box style={{ width: '75%' }}>
        {initialValues.workExperiences.map((items, index) => {
          const sortedFields = {
            title: items.title,
            employer: items.employer,
            isCurrentEmployer: items.isCurrentEmployer,
            startDate: items.startDate,
            endDate: items.endDate,
            description: items.description,
            financialTags: items.financialTags,
            softwareTags: items.softwareTags,
            industryTags: items.industryTags,
          }

          return (
            <Grid container key={index} spacing={5}>
              {Object.entries(sortedFields).map((field, index) => {
                const formattedFields = getWorkExperienceFields(field)

                const hasTags = Array.isArray(formattedFields?.value)
                return (
                  <Grid item key={index}>
                    <FieldName>{formattedFields?.label}</FieldName>
                    {!hasTags ? (
                      <FieldValue>
                        {formattedFields?.label === 'Description' ? (
                          <div dangerouslySetInnerHTML={{ __html: formattedFields?.value }}></div>
                        ) : (
                          formattedFields?.value
                        )}
                      </FieldValue>
                    ) : (
                      <>{getHtmlForEachTag(formattedFields?.value)}</>
                    )}
                  </Grid>
                )
              })}
            </Grid>
          )
        })}
      </Box>
      <WorkExperienceDialog
        open={open}
        handleClose={handleClose}
        initialValues={initialValues}
        setPropChange={setPropChange}
      />
    </>
  )
}

export default WorkExperienceRow
